webpackJsonp([114276838955818,60335399758886],{

/***/ 110:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(213);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(110);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 405:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(35);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _head = __webpack_require__(522);
	
	var _head2 = _interopRequireDefault(_head);
	
	__webpack_require__(405);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	  var linkList = _ref.linkList;
	  return _react2.default.createElement(
	    'footer',
	    { className: 'footer' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'nav',
	          { className: 'footer__nav' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav__list' },
	            _react2.default.createElement(
	              'li',
	              { className: 'nav__item' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: 'nav__link logo-img', to: '/' },
	                _react2.default.createElement('img', { src: _head2.default, alt: 'Logo' })
	              )
	            ),
	            linkList.map(function (linkItem) {
	              return _react2.default.createElement(
	                'li',
	                { key: linkItem.linkKey, className: 'nav__item' },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { activeClassName: 'active', className: 'nav__link', to: linkItem.linkPath },
	                  linkItem.linkName
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'nav__coop' },
	            'Copyright \xA9 2012 - ' + new Date().getFullYear()
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headmade.9577d2aa.png";

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(35);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _toggleOpen = __webpack_require__(79);
	
	var _toggleOpen2 = _interopRequireDefault(_toggleOpen);
	
	var _headmade = __webpack_require__(523);
	
	var _headmade2 = _interopRequireDefault(_headmade);
	
	__webpack_require__(406);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header.prototype.render = function render() {
	    var _props = this.props,
	        linkList = _props.linkList,
	        isOpen = _props.isOpen,
	        toggleOpen = _props.toggleOpen,
	        location = _props.location;
	
	    return _react2.default.createElement(
	      'header',
	      { className: 'header ' + (location === '/' ? "index" : "") },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'nav',
	            { className: 'header__nav' },
	            _react2.default.createElement(
	              'div',
	              { className: 'nav__logo' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: 'nav__linkLogo', to: '/' },
	                _react2.default.createElement('img', { src: _headmade2.default, alt: 'Logo' })
	              )
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'nav__list ' + (isOpen ? 'nav__list--active' : '') },
	              linkList.map(function (linkItem) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: linkItem.linkKey, className: 'nav__item' },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { activeClassName: 'active', className: 'nav__link', to: linkItem.linkPath },
	                    linkItem.linkName
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'hamburger-wrapper' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'c-hamburger c-hamburger--htx ' + (isOpen ? 'active' : ''),
	                  onClick: toggleOpen
	                },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'toggle men'
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = (0, _toggleOpen2.default)(Header);
	module.exports = exports['default'];

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (OriginalComponent) {
	  return function (_Component) {
	    _inherits(Wrapper, _Component);
	
	    function Wrapper() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Wrapper);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	        isOpen: false
	      }, _this.toggleOpen = function (ev) {
	        _this.setState({
	          isOpen: !_this.state.isOpen
	        });
	        ev && ev.preventDefault && ev.preventDefault();
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Wrapper.prototype.render = function render() {
	      return _react2.default.createElement(OriginalComponent, _extends({}, this.props, this.state, { toggleOpen: this.toggleOpen }));
	    };
	
	    return Wrapper;
	  }(_react.Component);
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pfagoraslabpro-bold.28b7469d.ttf";

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pfagoraslabpro-medium.ec250065.ttf";

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pfagoraslabpro-thin.ded70f47.ttf";

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(211);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(210);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(407);
	
	__webpack_require__(323);
	
	__webpack_require__(324);
	
	__webpack_require__(325);
	
	var _favicon = __webpack_require__(326);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// components
	
	
	// styles
	
	
	// fonts
	
	
	var linkList = [{ linkPath: '/projects', linkName: 'Проекты', linkKey: 1 }, { linkPath: '/contacts', linkName: 'Контакты', linkKey: 2 }, { linkPath: '/about', linkName: 'О нас', linkKey: 3 }];
	
	var TemplateWrapper = function (_React$Component) {
	  _inherits(TemplateWrapper, _React$Component);
	
	  function TemplateWrapper() {
	    _classCallCheck(this, TemplateWrapper);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TemplateWrapper.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'generalWrapper' },
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'Headmade LLC',
	        titleTemplate: '%s - \u041E\u041E\u041E \u0425\u044D\u0434\u043C\u0435\u0439\u0434, headmade.pro',
	        meta: [{ name: 'description', content: 'Headmade - ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ "ХЭДМЕЙД" (ООО ХЭДМЕЙД ), Казань, Республика Татарстан, ИНН 1657119572, ОГРН 1121690046411' }],
	        link: [{ rel: 'icon', href: _favicon2.default }]
	      }),
	      _react2.default.createElement(_Header2.default, { linkList: linkList, location: this.props.location.pathname }),
	      children(),
	      _react2.default.createElement(_Footer2.default, { linkList: linkList })
	    );
	  };
	
	  return TemplateWrapper;
	}(_react2.default.Component);
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.ff47c910.ico";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-ed8b148d46a8c95c5310.js